export enum PopupName {
  CONTACT = 'contact',
  INFO = 'info',
  GALLERY = 'gallery',
  SHARE = 'share',
}
